const mlPremadeColorsData = [
  {
    id: 1,
    name: "Ocean",
    header_color: "#1f6feb",
    header_gradient: { id: 1, first_color: "#1f6feb", second_color: "#0ea5e9", direction: 2 },
    header_color_scheme: 2,
    title_color: "#ffffff",
    description_color: "#ffffff",
    button_color: "#0ea5e9",
    button_text_color: "#ffffff",
    player_controls_color: "#0ea5e9",
  },
  {
    id: 2,
    name: "Graphite",
    header_color: "#111827",
    header_gradient: { id: 2, first_color: "#111827", second_color: "#6b7280", direction: 2 },
    header_color_scheme: 2,
    title_color: "#ffffff",
    description_color: "#d1d5db",
    button_color: "#374151",
    button_text_color: "#ffffff",
    player_controls_color: "#6b7280",
  },
  {
    id: 3,
    name: "Violet",
    header_color: "#6d28d9",
    header_gradient: { id: 3, first_color: "#6d28d9", second_color: "#a855f7", direction: 2 },
    header_color_scheme: 2,
    title_color: "#ffffff",
    description_color: "#f3e8ff",
    button_color: "#a855f7",
    button_text_color: "#ffffff",
    player_controls_color: "#c084fc",
  },
  {
    id: 4,
    name: "Neon Pulse",
    header_color: "#059669",
    header_gradient: { id: 4, first_color: "#059669", second_color: "#34d399", direction: 2 },
    header_color_scheme: 2,
    title_color: "#ffffff",
    description_color: "#d1fae5",
    button_color: "#10b981",
    button_text_color: "#022c22",
    player_controls_color: "#34d399",
  },
  {
    id: 5,
    name: "Sunset Blaze",
    header_color: "#ea580c",
    header_gradient: { id: 5, first_color: "#ea580c", second_color: "#f97316", direction: 2 },
    header_color_scheme: 2,
    title_color: "#ffffff",
    description_color: "#ffedd5",
    button_color: "#f97316",
    button_text_color: "#431407",
    player_controls_color: "#fb923c",
  },
  {
    id: 6,
    name: "Hot Pink",
    header_color: "#db2777",
    header_gradient: { id: 6, first_color: "#db2777", second_color: "#f472b6", direction: 2 },
    header_color_scheme: 2,
    title_color: "#ffffff",
    description_color: "#fce7f3",
    button_color: "#ec4899",
    button_text_color: "#500724",
    player_controls_color: "#f472b6",
  },
  {
    id: 7,
    name: "Electric Blue",
    header_color: "#2563eb",
    header_gradient: { id: 7, first_color: "#2563eb", second_color: "#38bdf8", direction: 2 },
    header_color_scheme: 2,
    title_color: "#ffffff",
    description_color: "#e0f2fe",
    button_color: "#0284c7",
    button_text_color: "#ffffff",
    player_controls_color: "#38bdf8",
  },
  {
    id: 8,
    name: "Golden Hour",
    header_color: "#ca8a04",
    header_gradient: { id: 8, first_color: "#ca8a04", second_color: "#facc15", direction: 2 },
    header_color_scheme: 2,
    title_color: "#1c1917",
    description_color: "#44403c",
    button_color: "#eab308",
    button_text_color: "#422006",
    player_controls_color: "#facc15",
  },
  {
    id: 9,
    name: "Crimson Rush",
    header_color: "#b91c1c",
    header_gradient: { id: 9, first_color: "#b91c1c", second_color: "#ef4444", direction: 2 },
    header_color_scheme: 2,
    title_color: "#ffffff",
    description_color: "#fee2e2",
    button_color: "#dc2626",
    button_text_color: "#ffffff",
    player_controls_color: "#f87171",
  },
  {
    id: 10,
    name: "Aqua Pop",
    header_color: "#0891b2",
    header_gradient: { id: 10, first_color: "#0891b2", second_color: "#22d3ee", direction: 2 },
    header_color_scheme: 2,
    title_color: "#ffffff",
    description_color: "#cffafe",
    button_color: "#06b6d4",
    button_text_color: "#083344",
    player_controls_color: "#22d3ee",
  },
];

export default mlPremadeColorsData;
